import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { transformChargingLocationDtoToModel } from '../transformer'
import { ChargingLocationDto } from '../dto'
import { ChargingLocationModel } from '../models'

/**
 * fetch the location where the vehicle is charged.
 * This location is selected by the user in the location dialog in vehicle list page.
 * Its more accurate than the installation location stored in user profile.
 */
export const fetchChargingLocation = async (
  installationId: number | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<ChargingLocationModel, AuthFetchError | Error>> => {
  if (installationId === undefined) {
    return new ApiResult<ChargingLocationModel, Error | AuthFetchError>(null, true, new Error('no installation id was given'))
  }

  try {
    const response = await authFetch<ChargingLocationDto | null>({
      path: `vehicles/installations/${installationId}/locations`,
      method: 'GET',
      endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const chargingLocation = transformChargingLocationDtoToModel(response.data)
      return new ApiResult<ChargingLocationModel, Error | AuthFetchError>(chargingLocation)
    }

    return new ApiResult<ChargingLocationModel, Error | AuthFetchError>(null, true, new Error('invalid status code'))
  } catch (error) {
    return handleFetchError<ChargingLocationModel>(error)
  }
}

/**
 * Update the charging location of the vehicle.
 * its more accurate than installation location stored in user profile.
 */
export const updateChargingLocation = async (
  payload: ChargingLocationModel,
  installationId: number | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  if (installationId === undefined) {
    return new ApiResult<boolean, Error | AuthFetchError>(null, true, new Error('no installation id was given'))
  }
  try {
    const response = await authFetch<string>({
      path: `vehicles/installations/${installationId}/locations`,
      method: 'PUT',
      payload: payload,
      endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT,
    })

    if (response.status === StatusCodes.NO_CONTENT || response.status === StatusCodes.CREATED) {
      return new ApiResult<boolean, Error | AuthFetchError>(true)
    }

    return new ApiResult<boolean, Error | AuthFetchError>(null, true, new Error('invalid status code'))
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}
